import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import { BodyM, HeadingSBold } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import CanPerform from 'components/CanPerform/CanPerform';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import ContactRow from './ContactRow';
import AssignmentInd from '@material-ui/icons/AssignmentIndOutlined';
import Button from 'components/CustomButtons/Button';
import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/accounts/accountDetailsSubpageStyle';
import { makeStyles } from '@material-ui/core';
import MoreDetails from './MoreDetails';
import Add from '@material-ui/icons/Add';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IOrganizationManagersProps {
	showAllManagers: () => void;
	account: types.organizations.IAccount;
	addManager: () => void;
}

const OrganizationManagersCard = ({ showAllManagers, account, addManager }: IOrganizationManagersProps) => {
	const classes = useStyles();
	return (
		<Card className={classes.contactsCard}>
			<CardBody>
				<div className={classes.contactsCardHeader}>
					<HeadingSBold color="primary-light">
						<>
							{translate('organization.details.organization.managers')}
							<ConditionalRender
								show={account.managers!.length > 0}
								onTrue={() => <>{` (${account.managers!.length})`}</>}
							/>
						</>
					</HeadingSBold>
					<ConditionalRender show={account.managers!.length > 0}>
						<CanPerform
							action="organizations:add-manager"
							yes={
								<div className={classes.allUsersManagers}>
									<MoreDetails />
								</div>
							}
						/>
					</ConditionalRender>
				</div>
				<GridContainer justify="flex-start" className={classes.contacts}>
					<>
						{account.managers!.slice(0, 4).map((manager: types.organizations.IUser) => (
							<GridItem xs={12} lg={6} key={manager.userId}>
								<ContactRow
									hexColor={manager.department?.uiColor}
									name={manager.userName}
									path={`/dashboard/users/${manager.userId}/user-details`}
									department={manager.department?.name}
									icon={<AssignmentInd />}
									accessible={manager.accessible}
									type="MANAGER"
								/>
							</GridItem>
						))}
						<ConditionalRender
							show={account.managers!.length <= 0}
							onTrue={() => (
								<div className={classes.noManagersAdmins}>
									<BodyM color="disabled-light">{translate('departments.no.managers.added')}</BodyM>
									<Button color="tertiary-light" withIcon onClick={addManager}>
										<Add />
										<>{translate('add.manager')}</>
									</Button>
									<CanPerform action="organizations:add-manager" yes={<MoreDetails />} />
								</div>
							)}
						/>
					</>
				</GridContainer>
				<ConditionalRender show={account.managers!.length > 0}>
					<div className={classes.editSection}>
						<div>
							<Button color="tertiary-light" id="edit-managers-button" onClick={showAllManagers}>
								<CanPerform
									action="organization:edit-managers"
									yes={<>{translate('edit')}</>}
									no={<>{translate('see.all')}</>}
								/>
							</Button>
						</div>
					</div>
				</ConditionalRender>
			</CardBody>
		</Card>
	);
};

export default OrganizationManagersCard;
